export default __webpack_public_path__ + "static/media/2020 Protein Plus - body2.6463dfec.jpg";